const getVoicemailOnly = baseId => ({
  id: 'message',
  name: 'Voicemail Only Campaign',
  description: 'Voicemail Only',
  version: 1,
  rootNodeId: `${baseId}message`,
  comment: 'template',
  nodes: [
    {
      type: 'IVR_NODE_MESSAGE',
      ivrNode: {
        id: `${baseId}message`,
        name: 'Message',
        description: 'Message',
        nextId: `${baseId}voicemail`,
        message: {
          message:
            "Thanks for contacting us! We are currently not taking phone calls, but you can leave us a voicemail, and we'll get back to you as soon as possible. Please leave a voicemail with your name, number and reason for calling and we'll get back to you soon!",
          type: 'TEXT',
          language: 'en-US',
          voice: '',
        },
      },
    },
    {
      type: 'IVR_NODE_VOICEMAIL',
      ivrNode: {
        id: `${baseId}voicemail`,
        name: 'Voicemail',
        description: 'Voicemail',
        selection: '_voicemail',
      },
    },
  ],
});

export default getVoicemailOnly;
